import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/contexts/AuthContext";
import { useUnreadNotifications } from "@/hooks/useUnreadNotifications";
import UnreadBadge from "@/components/UnreadBadge";

const NotificationBell = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { total } = useUnreadNotifications();

  if (!user) return null;

  const label =
    total > 0
      ? `${t("notifications.title", "Bildirimler")} (${total})`
      : t("notifications.title", "Bildirimler");

  return (
    <button
      type="button"
      onClick={() => navigate(total > 0 ? "/notifications?unread=1" : "/notifications")}
      aria-label={label}
      className="relative h-9 w-9 inline-flex items-center justify-center rounded text-muted-foreground hover:text-foreground hover:bg-secondary/50 transition-colors"
    >
      <Bell size={16} />
      <UnreadBadge count={total} className="absolute -top-0.5 -right-0.5" />
    </button>
  );
};

export default NotificationBell;
